
import React, { useEffect, useRef, useState } from "react";
import {
	Button,
	Col,
	Form,
	Modal,
	Overlay,
	Popover,
	Row,
	Tooltip,
} from "react-bootstrap";
import ReactSelect from "react-select";
import { useDispatch, useSelector } from "react-redux";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";

import toast from "react-hot-toast";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "../../../API/axios";
import { fetchSalaryType } from "../../../redux/actions/salaryTypeAction";
import { fetchDesignation } from "../../../redux/actions/designationAction";
import { fetchWorkLocationTypeData } from "../../../redux/actions/workLLocationTypeAction";
import { fetchWorkLevelTypeData } from "../../../redux/actions/workLevelTypeAction";
import { fetchJobType } from "../../../redux/actions/jobTypeAction";
import { clearCityList, fetchCityData } from "../../../redux/actions/citiesAction";
import { fetchAllOrgsData } from "../../../redux/actions/getAllOrgsAction";
import { fetchCompanyData } from "../../../redux/actions/getCompaniesAction";
import { customStyles } from "../../../selectStyles";
// import ExcelFile from "../../../assets/Wok.xlsx"
import ExcelFile from "../../../assets/excelkhoj/Job Post Bulk Upload Sample.xlsx";
import { fetchAllCompany } from "../../../redux/actions/getAllCompanyAction";
import { fetchSkill } from "../../../redux/actions/skillAction";
import { fetchIndustryData } from "../../../redux/actions/industryActions";
import { fetchCurrency } from "../../../redux/actions/getcurrencyAction";
import ReactQuill from "react-quill";

const PostJobRecruiter = () => {
	const navigate = useNavigate();

	// ...............................Post Job Start.......................................
	const sessionId = localStorage.getItem("sessionId");
	const UserType = localStorage.getItem("userType");
	const companyUId = localStorage.getItem("userUID");
	const [images, setImages] = useState([]);
	const [display, setDisplay] = useState(false);
	const [minimumSalary, setMinimumSalary] = useState("");
	const [maximumSalary, setMaximumSalary] = useState("");
	const [currency, setCurrency] = useState("");
	const [jobTitle, setJobTitle] = useState("");
	const [jobID, setjobID] = useState("");
	const [requirement, setRequirement] = useState("");
	const [jobDescription, setjobDescription] = useState("");
	const [isCompanySelected, setIsCompanySelected] = useState(false);
	const [InsName, setInsName] = useState("");



	// add associated company 
	const targetRef = useRef(null);
	const [showTooltip, setShowTooltip] = useState(false);


	const [show, setShow] = useState(false);
	const handleShow = () => setShow(true);
	const handleClose = () => {
		setShow(false);
	};

	const AddCompany = async (e) => {
		e.preventDefault();
		setDisplay(true);
		const body = {
			sessionId: sessionId,
			compId: companyListId,
			orgType: orgType

		};
		// console.log("body", body);
		// if (companyListId === "") {
		// 	toast.error("select Company")
		// } else {

		try {
			const res = await axios.post("/Recruiter/AddAssociateCompany", body);
			toast.success(res.data.message);
			setCompanyListId("");
			getAllCompanyList();
			setShowTooltip(false)
		} catch (error) {
			if (error.response && error.response.status === 404) {
				toast.error(error.response.data.message);
			} else {
				toast.error(error.response?.data?.message);
			}
			// }
		}
	};

	const toggleTooltip = () => {
		setShowTooltip((prev) => !prev);
	};



	const handleImageUpload = (e) => {
		const files = Array.from(e.target.files);
		setImages(files);
	};

	const removeImage = (index) => {
		setImages(images.filter((_, i) => i !== index));
	};

	// .......................... Edit-Candid Disabled and Enabaled
	const [formChanged, setFormChanged] = useState(false);
	const [isSubmitting, setIsSubmitting] = useState(false);

	const stripHtmlTags = (html) => {
		const doc = new DOMParser().parseFromString(html, "text/html");
		return doc.body.textContent || "";
	};


	const handleFieldChange = (setter, value, fieldName) => {
		// ReactQuill ka data properly clean karein
		const cleanedValue = fieldName === "jobDescription" || fieldName === "requirement"
			? stripHtmlTags(value)
			: value;

		setter(value); // State update karein original value ke saath

		// Convert non-string values to empty strings
		const updatedCompanyAssoListId = fieldName === "companyAssoListId" ? String(cleanedValue || "") : String(companyAssoListId || "");
		const updatedJobTitle = fieldName === "jobTitle" ? cleanedValue : jobTitle || "";
		const updatedMinimumSalary = fieldName === "minimumSalary" ? cleanedValue : minimumSalary || "";
		const updatedMaximumSalary = fieldName === "maximumSalary" ? cleanedValue : maximumSalary || "";
		const updatedCurrency = fieldName === "currency" ? cleanedValue : currency || "";
		const updatedSalaryTypeSearch = fieldName === "salaryTypeSearch" ? cleanedValue : salaryTypeSearch || "";
		const updatedDesignationSearch = fieldName === "designationSearch" ? cleanedValue : designationSearch || "";
		const updatedWorkLevelSearch = fieldName === "workLevelSearch" ? cleanedValue : workLevelSearch || "";
		const updatedWorkLocationSearch = fieldName === "workLocationSearch" ? cleanedValue : workLocationSearch || "";
		const updatedJobTypeSearch = fieldName === "jobTypeSearch" ? cleanedValue : jobTypeSearch || "";
		const updatedCityListSearch = fieldName === "cityListSearch" ? cleanedValue : cityListSearch || "";
		const updatedRequirement = fieldName === "requirement" ? cleanedValue : requirement || "";
		const updatedJobDescription = fieldName === "jobDescription" ? cleanedValue : jobDescription || "";

		// Validate all required fields
		const isValid =
			updatedCompanyAssoListId.trim() !== "" &&
			updatedJobTitle.trim() !== "" &&
			updatedMinimumSalary !== "" &&
			updatedMaximumSalary !== "" &&
			Number(updatedMaximumSalary) >= Number(updatedMinimumSalary) && // Ensure max salary is greater than min salary
			updatedCurrency.trim() !== "" &&
			updatedSalaryTypeSearch?.toString().trim() !== "" &&
			updatedDesignationSearch?.toString().trim() !== "" &&
			updatedWorkLevelSearch?.toString().trim() !== "" &&
			updatedWorkLocationSearch?.toString().trim() !== "" &&
			updatedJobTypeSearch?.toString().trim() !== "" &&
			updatedCityListSearch?.toString().trim() !== "" &&
			updatedRequirement.trim() !== "" &&
			updatedJobDescription.trim() !== "";

		setFormChanged(isValid);
	};

	// ..............................  Edit-Candid Disabled and Enabaled

	// .............................. Bulk upload excel file  Enabled 
	const [formChangedBulk, setFormChangedBulk] = useState(false); // Track if form is modified
	const [isSubmittingBulk, setIsSubmittingBulk] = useState(false);
	const [uploadedFile, setUploadedFile] = useState(null); // Track uploaded file

	// Handle changes and mark form as modified
	const handleFieldChangeBulk = (setter, value, fieldName) => {
		setter(value);
		// setFormChanged(true); 
		// validateForm(fieldName, value);
		if (fieldName === "fileUpload") {
			handleFileUpload(value);
		} else {
			validateForm(fieldName, value);
		}
	};

	// Function to check if all required fields are filled
	const validateForm = (fieldName, value) => {
		const updatedCompanyAssoListId = fieldName === "companyAssoListId" ? value : companyAssoListIdBulk;
		const updatedFile = fieldName === "fileUpload" ? value : uploadedFile;

		if (updatedCompanyAssoListId && updatedFile) {
			setFormChangedBulk(true);
		} else {
			setFormChangedBulk(false);
		}
	};

	// .............................. Bulk upload excel file  Disabled 
	// Handle file selection
	const handleFileUpload = (e) => {
		const file = e.target.files[0];
		setUploadedFile(file);
		validateForm("fileUpload", file);
		if (file) {
			setFileName(file.name);
			setSelectedFile(file);
		}
	};

	// const handleFileUpload = (e) => {
	// 	const file = e.target.files[0];
	// 	if (file) {
	// 		setFileName(file.name);
	// 		setSelectedFile(file);
	// 	}
	// };



	const AddJobRecruiter = async () => {
		setDisplay(true);
		setIsSubmitting(true); // Disable the button during submission
		setIsSubmittingBulk(true); // Disable the button during submission

		// 	const computedTagId = companyAssoListId 
		// ? compList.find((c) => c.value === companyAssoListId)?.tagId || 3
		// : assoTagId;

		const body = {
			sessionId: sessionId,
			compType: UserType,
			compUid: companyUId,
			cityId: cityListSearch,
			jbTypId: jobTypeSearch,
			workLevelType: workLevelSearch,
			workLocationType: workLocationSearch,
			designationName: designationSearch,
			salaryTypeId: salaryTypeSearch,
			minSalary: minimumSalary,
			maxSalary: maximumSalary,
			currency: currency,
			title: jobTitle,
			description: jobDescription,
			requirement: requirement,
			assctdCompId: companyAssoListId,
			orgType: assoTagId === 2 || assoTagId === 3 ? assoTagId : 3,
			// orgType: assoTagId === 2 ? 2 : 3 ,
		};
		console.log("body", body);

		if (
			companyAssoListId === "" ||
			cityListSearch === "" ||
			jobTypeSearch === "" ||
			workLevelSearch === "" ||
			workLocationSearch === "" ||
			designationSearch === "" ||
			salaryTypeSearch === "" ||
			minimumSalary === "" ||
			maximumSalary === "" ||
			requirement === "" ||
			currency === "" ||
			jobTitle === "" ||
			jobDescription === ""

		) {
			toast.error("Please fill all the required fields");
			setIsSubmitting(false); // Re-enable the button if validation fails
			setIsSubmittingBulk(false); // Re-enable the button if validation fails
		}
		else {
			try {
				const res = await axios.post("/Job/AddJobByRecruiter", body);
				console.log("gashgdjdgsa", res);
				toast.success(res.data.message);
				const jobid = res.data.responseData.id
				console.log(jobid);
				setjobID(jobid)
				setSalaryTypeSearch();
				setDesignationSearch("");
				setworkLocationSearch("");
				setworkLevelSearch("");
				setjobTypeSearch("");
				setcityListSearch("");
				setMinimumSalary("");
				setMaximumSalary("");
				setRequirement("")
				setjobDescription("")
				setJobTitle("");
				handleInfoShow()
				getJobDetail(jobid)
				setFormChanged(false); // Disable the button after successful update
			} catch (error) {
				if (error.response && error.response.status === 404) {
					toast.error(error.response.data.message);
				} else {
					toast.error(error.response?.data?.message);
				}
			} finally {
				setIsSubmitting(false); // Ensure the button is re-enabled in case of failure
				setIsSubmittingBulk(false); // Ensure the button is re-enabled in case of failure
			}
		}
	};

	const dispatch = useDispatch();

	const [salaryTypeSearch, setSalaryTypeSearch] = useState("");
	const { salaryTypeList, selectedSalaryTypeId } = useSelector(
		(state) => state.salaryType
	);

	useEffect(() => {
		dispatch(fetchSalaryType());
	}, [dispatch]);

	const handleSalaryType = (selectedOption) => {
		if (selectedOption) {
			// dispatch(selectSalaryType(selectedOption.value));
			setSalaryTypeSearch(selectedOption.value);
		} else {
			setSalaryTypeSearch(null);
		}
	};
	// ...............................Salary Dropdown.......................................

	// ...............................Designation Dropdown.......................................
	const [designationSearch, setDesignationSearch] = useState("");
	const { designationList, selectedDesignationId } = useSelector(
		(state) => state.designation
	);
	useEffect(() => {
		dispatch(fetchDesignation());
	}, [dispatch]);

	// const handleDesignation = (selectedOption) => {
	// 	if (selectedOption) {
	// 		// dispatch(selectDesignation(selectedOption.value));
	// 		setDesignationSearch(selectedOption.value);
	// 	} else {
	// 		setDesignationSearch(null);
	// 	}
	// };

	const designationInputChange = (inputValue, { action }) => {
		if (action === "input-change") {
			console.log("Typed value:", inputValue); // Check if typing is detected
			setDesignationSearch(inputValue);
		}
	};
	// ...............................Designation Dropdown.......................................

	// ...............................Location Dropdown.......................................
	const [workLocationSearch, setworkLocationSearch] = useState("");

	const { workLocation, selectedCategoryId } = useSelector(
		(state) => state.workLocationType
	);
	useEffect(() => {
		dispatch(fetchWorkLocationTypeData());
	}, [dispatch]);

	const handleWorkLoc = (selectedOption) => {
		if (selectedOption) {
			// dispatch(selectWorkLocation(selectedOption.label));
			setworkLocationSearch(selectedOption.value);
		} else {
			setworkLocationSearch(null);

		}
	};
	// ...............................Location Dropdown.......................................

	// ...............................Work Level Dropdown.......................................
	// Fetch work level data on component mount
	const [workLevelSearch, setworkLevelSearch] = useState("");
	const { workLevelList, selectedworkLevelId } = useSelector(
		(state) => state.workLevelType
	);
	// console.log('Work Level', workLevelList, selectedworkLevelId);

	useEffect(() => {
		dispatch(fetchWorkLevelTypeData());
	}, [dispatch]);

	const handleWorkLevel = (selectedOption) => {
		if (selectedOption) {
			// dispatch(selectWorkLevel(selectedOption.value));
			setworkLevelSearch(selectedOption.value);
		} else {
			setworkLevelSearch(null);
		}
	};
	// ...............................Work Level Dropdown.......................................

	// ...............................Job Type Dropdown.......................................

	const [jobTypeSearch, setjobTypeSearch] = useState("");
	const { jobTypeList, selectedJobTypeId } = useSelector(
		(state) => state.jobType
	);
	useEffect(() => {
		dispatch(fetchJobType());
	}, [dispatch]);

	const handleJobType = (selectedOption) => {
		if (selectedOption) {
			// dispatch(selectJobType(selectedOption.value));
			setjobTypeSearch(selectedOption.value);
		} else {
			setjobTypeSearch(null);

		}
	};
	// ...............................Job Type Dropdown.......................................

	// ...............................currency Dropdown.......................................

	const { currencyList, selectedcurrencyId } = useSelector(
		(state) => state.currency
	);
	useEffect(() => {
		dispatch(fetchCurrency());
	}, [dispatch]);

	const handleCurrency = (selectedOption) => {
		if (selectedOption) {
			setCurrency(selectedOption.label);
		} else {
			setCurrency(null);

		}
	};

	// ...............................City Dropdown.......................................

	const [neworgType, setneworgType] = useState("");
	const [neworgId, setneworgId] = useState("");
	const [orgCity, setOrgCity] = useState(null);
	const [cityListSearch, setcityListSearch] = useState("");
	const { cityList, selectedcityId } = useSelector((state) => state.cities);

	useEffect(() => {
		dispatch(fetchCityData());
		return () => {
			dispatch(clearCityList())
		}
	}, [dispatch]);

	const handleCityInputChange = (inputValue) => {
		dispatch(fetchCityData(inputValue));
	};

	const handleCitySelect = (selectedOption) => {
		if (selectedOption) {
			setcityListSearch(selectedOption.value);
		} else {
			setcityListSearch(null);

		}
	};

	const handleCitySelect1 = (selectedOption) => {
		if (selectedOption) {
			setOrgCity(selectedOption.value);
		}
	};

	const [fileName, setFileName] = useState("Wok.xlsx");
	const [selectedFile, setSelectedFile] = useState(null);

	const [showBulkModal, setShowBulkModal] = useState(false);
	const handleShowBulkModal = () => setShowBulkModal(true);
	const handleCloseBulkModal = () => {
		setShowBulkModal(false);
		setSelectedFile(null);
	};

	const downloadExcel = () => {
		const link = document.createElement("a");
		link.href = ExcelFile;
		link.download = fileName;
		link.click();
	};

	// const handleFileUpload = (e) => {
	// 	const file = e.target.files[0];
	// 	if (file) {
	// 		setFileName(file.name);
	// 		setSelectedFile(file);
	// 	}
	// };

	// const uploadFile = () => {

	// 	setIsSubmittingBulk(true); // Disable the button during submission

	// 	const body = {
	// 		sessionId: sessionId,
	// 		assctdCompId: companyAssoListIdBulk,
	// 		orgType: assoTagIdBulk === 2 || assoTagIdBulk === 3 ? assoTagIdBulk : 3,
	// 		// orgType: assoTagId === 2 ? 2 : 3 ,
	// 	};
	// 	console.log("body", body);

	// 	if (
	// 		companyAssoListIdBulk === ""

	// 	) {
	// 		toast.error("Please fill all the required fields");
	// 		setIsSubmittingBulk(false); // Re-enable the button if validation fails
	// 	}


	// 	if (!selectedFile) {
	// 		alert("Please select a file to upload!");
	// 		return;
	// 	}
	// 	const formData = new FormData();
	// 	formData.append("file", selectedFile);



	// 	console.log("Uploading file:", selectedFile.name);
	// };
	const [isDownloading, setIsDownloading] = useState(false);

	const uploadFile = async (e) => {
		setIsDownloading(true);
		e.preventDefault();
		try {
			//setDisplay(true);
			setIsSubmitting(true);
			{
				const formData = new FormData();
				formData.append("AssctdCompId", companyAssoListIdBulk);
				formData.append("OrgType", assoTagIdBulk);
				formData.append("File", uploadedFile);
				formData.append("SessionId", sessionId);

				console.log("Profile FormData:", formData);

				// First API call to submit the profile data
				const res = await axios.post(`/Job/BulkUploadByRecruiter?DuplicateSkip=${duplicateSkip}`, formData, {
					headers: {
						"Content-Type": "multipart/form-data",
					},
				});

				console.log("Profile Response:", res);
				toast.success(res.data.message);
				handleCloseBulkModal()
				setSelectedFile(null)
				setDuplicateSkip(false);
				setCompanyAssoListIdBulk("");
				setIsDownloading(false);
			}
		} catch (error) {
			if (error.response?.status === 400) {
				toast.error(error.response.data.message)
				setIsDownloading(false);
			} else {
				toast.error(error.response?.data.message);
				setIsDownloading(false);
			}
			console.error(error)
		} finally {
			setIsSubmitting(false);
		}
	};

	// const uploadFile = async (e) => {
	// 	e.preventDefault();
	// 	try {
	// 		// setDisplays(true);
	// 		setIsSubmitting(true); // Disable the button during submission
	// 		{
	// 			const formData = new FormData();
	// 			formData.append("ClssID", selectedClassForBulk);
	// 			formData.append("File", uploadedFile);
	// 			formData.append("SessionId", sessionId);

	// 			console.log("Profile FormData:", formData);

	// 			// First API call to submit the profile data
	// 			const res = await axios.post("/Candidate/AddBulkCnddtByInstt", formData, {
	// 				headers: {
	// 					"Content-Type": "multipart/form-data",
	// 				},
	// 			});

	// 			console.log("Profile Response:", res);
	// 			toast.success(res.data.message);

	// 		}
	// 	} catch (error) {
	// 		if (error.response.status === 400) {
	// 			toast.error(error.response.data.message)
	// 		} else {
	// 			toast.error(error.response.data.message);
	// 		}
	// 		console.error(error)
	// 	} finally {
	// 		setIsSubmitting(false); // Ensure the button is re-enabled in case of failure
	// 	}
	// };


	// ...............................City Dropdown.......................................

	// ...............................Organization Dropdown.......................................

	const [getallorgsId, setGetAllOrgsId] = useState("");
	const [orgType, setOrgType] = useState("");
	const { getallorgsList, selectedgetallId } = useSelector(
		(state) => state.getallorgs
	);
	useEffect(() => {
		dispatch(fetchAllOrgsData());
	}, [dispatch]);

	const handleOrganization = (selectedOption) => {
		if (selectedOption) {
			// dispatch(selectAllOrgs(selectedOption.value));
			setGetAllOrgsId(selectedOption.value);
			setOrgType(selectedOption.tagId);
		}
	};

	// ...............................Organization Dropdown.......................................

	// ...............................Company Category DDL.......................................
	const [companyListId, setCompanyListId] = useState("");
	const [selectedOptionData, setSelectedOptionData] = useState("");
	const { getAllcompaniesList, selectedcompaniesId } = useSelector(
		(state) => state.getAllCompany
	);

	useEffect(() => {
		dispatch(fetchAllCompany());
	}, [dispatch]);

	const handleSelectCompany = (selectedOption) => {
		console.log("selectedOption==============>", selectedOption);

		if (selectedOption) {
			console.log("selectedOption===>", selectedOption.value);

			// dispatch(selectGetCompanies(selectedOption.value));
			setSelectedOptionData(selectedOption);
			setCompanyListId(selectedOption.value);
			setOrgType(selectedOption.tag);
			setIsCompanySelected(!!selectedOption)
		} else {
			setCompanyListId(null);
		}
	};
	console.log("companyListId", companyListId);

	// ...............................Company Category DDL.......................................

	// ........................................Job info start..........................

	const [jobInfo, setJobInfo] = useState("");
	const [showInfoModal, setShowInfoModal] = useState(false);
	const handleInfoShow = () => setShowInfoModal(true);
	const handleCloseInfoModal = () => setShowInfoModal(false);

	const getJobDetail = (jobID) => {
		axios
			.get(`/Job/GetJobDetails?JobId=${jobID}`)
			.then((response) => {
				const res = response.data.responseData;
				setJobInfo(res);
				console.log("edit data", res);
			})
			.catch((error) => {
				if (error.response && error.response.status === 404) {
					console.log(error);
				} else {
					console.log(error);
				}
			});
	};

	// ........................................Job Info End..........................

	const [showaddskill, setShowaddskill] = useState(false);
	const handleSkillShow = () => setShowaddskill(true);
	const handleCloseaddskill = () => setShowaddskill(false);

	// ...............................Industry DDL.......................................

	const [industryId, setIndustryId] = useState("");
	const { industryList, selectedIndustryId } = useSelector(
		(state) => state.industry
	);
	useEffect(() => {
		dispatch(fetchIndustryData());
	}, [dispatch]);

	const handleIndustrySelect = (val) => {
		setIndustryId(val.value);
	};
	const handleSubmit = async (e) => {
		e.preventDefault();
		setDisplay(true);
		const body = {
			sessionId: sessionId,
			jobId: jobID,
			skillIds: [skillListId]
		};
		console.log("body", body);
		if (industryId === '' || skillName === '') {
			toast.error('Please fill all the required fields')
		} else {
			try {
				const res = await axios.post("/Job/SetJobSkills", body);
				toast.success(res.data.message);
				handleCloseaddskill();
				navigate("/job/My-Jobs")

				setDisplay(false)
			} catch (error) {
				if (error.response && error.response.status === 404) {
					toast.error(error.response.data.message);
				} else {
					toast.error(error.response?.data?.message);
				}
			}
		}
	};
	// ...............................Industry DDL.......................................

	// ...............................skill DDL.......................................
	const [skillListId, setSkillListId] = useState("");
	const [skillName, setSkillName] = useState("");
	const { skillList, selectedSkillId } = useSelector(
		(state) => state.skill
	);
	console.log("skillList", skillList);

	useEffect(() => {
		if (industryId) {
			dispatch(fetchSkill(industryId)); // Pass industryId to the action
		}
	}, [dispatch, industryId]);

	const handleSkillSelect = (selectedOption) => {
		if (selectedOption) {
			//   dispatch(selectSkill(selectedOption.value));
			setSkillListId(selectedOption.value);
			setSkillName(selectedOption.label)
		}
	};
	// ...............................skill DDL.......................................


	const [companyList, setCompanyList] = useState([]);
	const [assoTagId, setAssoTagId] = useState([]);
	const [companyAssoListId, setCompanyAssoListId] = useState("");
	const [isCompanyAssoSelected, setIsCompanyAssoSelected] = useState(true);
	const [selectedAssoOptionData, setSelectedAssoOptionData] = useState("");

	// .................... Bulk Upload Excel
	const [companyListBulk, setCompanyListBulk] = useState([]);
	const [assoTagIdBulk, setAssoTagIdBulk] = useState([]);
	const [companyAssoListIdBulk, setCompanyAssoListIdBulk] = useState("");
	// const [isCompanyAssoSelectedBulk, setIsCompanyAssoSelectedBulk] = useState(true);
	// const [selectedAssoOptionDataBulk, setSelectedAssoOptionDataBulk] = useState("");
	// .................... Bulk Upload Excel


	const getAllCompanyList = () => {
		const data = { sessionId: sessionId };

		axios
			.post(`/Recruiter/GetAssociatedCompanies`, data)
			.then((response) => {
				const res = response.data.responseData;
				console.log("getAllCompanyList", res);

				const compList = res.map((val) => ({
					value: val.id,
					label: val.name,
					tagId: val.tagID
				}));
				console.log("compList", compList);


				setCompanyList(compList);
				setCompanyListBulk(compList);

				// 	if (compList.length > 0) {
				// 	console.log("Setting assoTagId:", compList[0].tagId);
				// 	setAssoTagId(compList[0].tagId); 
				// }
				// if (compList.length > 0) {
				// 	setAssoTagId(compList[0].tagId);  // Setting tagId from the first company
				// }
				// Ensure fields remain disabled until a company is selected
				setCompanyAssoListId("");
				setCompanyAssoListIdBulk("")
				setIsCompanyAssoSelected(false);
				setSelectedAssoOptionData("");
			})
			.catch((error) => {
				console.log("error", error);
			});
	};



	useEffect(() => {
		getAllCompanyList(); // Fetch the company list on mount
	}, []);




	// .................................shortDescription

	// const addTargetBlankToAnchors = (html) => {
	// 	const div = document.createElement('div');
	// 	div.innerHTML = html;

	// 	const anchors = div.querySelectorAll('a');
	// 	anchors.forEach(anchor => {
	// 		anchor.setAttribute('target', '_blank');
	// 		anchor.setAttribute('rel', 'noopener noreferrer');
	// 	});

	// 	return div.innerHTML;
	// };
	const addTargetBlankToAnchors = (html) => {
		if (!html) return ''; // Ensure we don't process null values

		const div = document.createElement('div');
		div.innerHTML = html;

		// Select only <a> tags and modify them
		const anchors = div.querySelectorAll('a');
		anchors.forEach(anchor => {
			anchor.setAttribute('target', '_blank');
			anchor.setAttribute('rel', 'noopener noreferrer');
		});

		return div.innerHTML; // Return cleaned HTML
	};

	const linkifyContent = (htmlContent) => {
		const urlPattern = /(?<!href="|">)(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi;
		return htmlContent.replace(urlPattern, function (url) {
			return `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`;
		});
	};
	// .................................shortDescription
	// const [designation, setDesignation] = useState("");
	const handleDesignation = (inputValue, { action }) => {
		if (action === "input-change") {
			setDesignationSearch(inputValue);
		}
	};

	const [inputValue, setInputValue] = useState('');
	const [selectedSkills, setSelectedSkills] = useState([]);

	const handleInputChange = (inputValue, { action }) => {
		if (action === 'input-change') {
			setInputValue(inputValue);
		}
	};

	const handleChange = (selectedOptions) => {
		setSelectedSkills(selectedOptions);
		handleSkillSelect(selectedOptions); // Call your original skill select handler
	};

	const combinedOptions = [...skillList];
	if (inputValue && !skillList.find(opt => opt.label === inputValue)) {
		combinedOptions.push({ value: inputValue, label: inputValue });
	}

	const [duplicateSkip, setDuplicateSkip] = useState(false);
	const handleToggle = (e) => {
		setDuplicateSkip(e.target.checked);
	};

	return (
		<>
			<div className="main-container mb-5 postJob">
				<div className="content-wrapper">
					<div className="title delete-title d-flex justify-content-between align-items-center Title-header-Mobile
                        post-new-job-title">
						<h1 className="f-600">
							<span className="orange-box"></span> Post A New Job
						</h1>
						<div className="bulk-upload-container">
							<Button className="mainBtn apply-job ms-2 py-0 bulk-upload-btn"
								onClick={() => {
									handleShowBulkModal()
								}}>
								Bulk upload
							</Button>
						</div>
					</div>

					<div className="card Alertcard PostCard">

						<div className=" col-md-12 post-job-details-form p-0 pt-3">
							<div controlId="post-form-row my-0  ">
								<div className="mb-2 main-company-disabled">
									<div className="post-form-group mb-0 placeholder-from-react-select">

										<label htmlFor="about">
											Company <span style={{ color: "red" }} className="f-500">* {selectedAssoOptionData !== "" ? "" : "Select associate company (Or manage in setting)"}</span>
										</label>
										{/* <ReactSelect
												options={companyList}
												onChange={(option) => {
												    handleFieldChange(setCompanyAssoListId, option ? option.value : ""); // Track changes
													setCompanyAssoListId(option ? option.value : ""); 
													setIsCompanyAssoSelected(!option);
													setSelectedAssoOptionData(option ? option.label : "");
												}}
												value={companyList.find((option) => option.value === companyAssoListId) || null}
												placeholder="Select Company"
												classNamePrefix="react-select"
												className="form-control"
												styles={customStyles}
												isClearable
											/> */}
										<ReactSelect
											options={companyList}
											onChange={(option) => {
												handleFieldChange(setCompanyAssoListId, option ? option.value : "", "companyAssoListId"); //  Correct fieldName
												setCompanyAssoListId(option ? option.value : "");
												setIsCompanyAssoSelected(!!option); //  Enable fields only when a company is selected
												setSelectedAssoOptionData(option ? option.label : "");
												setAssoTagId(option ? option.tagId : "");
											}}
											onPaste={(e) => handleFieldChange(setJobTitle, e.clipboardData.getData("text"), "jobTitle")}
											value={companyList.find((option) => option.value === companyAssoListId) || null}
											placeholder="Select Company"
											classNamePrefix="react-select"
											className="form-control"
											styles={customStyles}
											isClearable
										/>
									</div>
								</div>
							</div>
						</div>
						<div className=" col-md-12 post-job-details-form p-0  mb-2">

							<a
								href="#"
								ref={targetRef}
								onClick={(e) => {
									e.preventDefault();
									toggleTooltip();
								}}
								className="createModal"
							>
								Add New
							</a>
							<Overlay
								target={targetRef.current}
								show={showTooltip}
								placement="right"
								rootClose
								container={document.querySelector(".modal")}
								onHide={() => setShowTooltip(false)} // Close when clicking outside
							>
								<Popover id="popover-basic" className="overlay-popover-modal" >
									<Popover.Header as="h3" className="Dark-Body-Card-group">Add Associated</Popover.Header>
									<Popover.Body className="Dark-Body-Card-group">
										<Form>
											<Row>
												<Col md={12}>
													<Form.Group controlId="Name_Title">
														<Form.Label className="class-type Text-mb-Create">
															Associated Company
															<span style={{ color: "red" }} className="ms-2">
																*
															</span>

														</Form.Label>
													</Form.Group>
													<ReactSelect
														options={getAllcompaniesList}
														onChange={handleSelectCompany}
														value={
															getAllcompaniesList.find(
																(option) => option.value === companyListId
															) || null
														}
														placeholder="Select Company"
														classNamePrefix="react-select"
														className="form-control Dark-Input-from-group"
														styles={customStyles}
														isClearable
													/>
													{display && !companyListId ? (
														<span className="error_msg_lbl">Select Company</span>
													) : null}

												</Col>

											</Row>
											<div className="add-class-submit-button  mt-2 d-flex justify-content-center">
												<Button onClick={AddCompany} >Add</Button>
												<Button variant="secondary"
													className="ms-2"
													size="sm"
													onClick={() => setShowTooltip(false)} > Cancel </Button>
											</div>
										</Form>
									</Popover.Body>
								</Popover>
							</Overlay>
						</div>





						{/* ....................... 1 Row ......................... */}
						<div className="post-job-details-form p-0 ">
							<div className="post-form-row my-0">
								<div className="post-form-group placeholder-from-react-select">
									<label htmlFor="about">
										Job Title <span style={{ color: "red" }}>*</span>
									</label>
									<input
										type="text"
										placeholder="Job Title"
										value={jobTitle}
										// onChange={(e) => setJobTitle(e.target.value)}
										// onChange={(e) => handleFieldChange(setJobTitle, e.target.value)}
										onChange={(e) => handleFieldChange(setJobTitle, e.target.value, "jobTitle")}
										onPaste={(e) => handleFieldChange(setJobTitle, e.clipboardData.getData("text"), "jobTitle")}
										disabled={!isCompanyAssoSelected}
									/>
									{/* {display && !jobTitle ? (
										<span className="error_msg_lbl">Enter Job Title</span>
									) : null} */}
								</div>

								<div className="post-form-group placeholder-from-react-select">
									<label htmlFor="about">
										Currency <span style={{ color: "red" }}>*</span>
									</label>
									<ReactSelect
										// options={currencyList}
										options={currencyList.map(option => ({
											...option,
											label: option.label.toUpperCase()
										}))}
										// onChange={(option) => handleFieldChange(setCurrency, option ? option.label : "")} // Track changes
										onChange={(option) => handleFieldChange(setCurrency, option ? option.label : "", "currency")}
										value={
											currencyList
												.map(option => ({ ...option, label: option.label.toUpperCase() })) // Ensure matching uppercase options
												.find(option => option.label === currency) || null
										}
										placeholder="Select Currency"
										styles={customStyles}
										classNamePrefix="react-select"
										className="form-control"
										isDisabled={!isCompanyAssoSelected}
										isClearable
									/>

									{/* {display && !currency ? (
										<span className="error_msg_lbl">Select Currency </span>
									) : null} */}
								</div>


							</div>
						</div>

						{/* ....................... 2 Row ......................... */}
						<div className="post-job-details-form p-0">
							<div className="post-form-row my-0">
								<div className="post-form-group placeholder-from-react-select">
									<label htmlFor="about">
										Minimum Salary <span style={{ color: "red" }}>*</span>
									</label>
									<input
										type="number"
										placeholder="Type Salary"
										value={minimumSalary}
										// onChange={(e) => setMinimumSalary(e.target.value)}
										// onChange={(e) => handleFieldChange(setMinimumSalary, e.target.value)}
										onChange={(e) => handleFieldChange(setMinimumSalary, e.target.value, "minimumSalary")}
										onPaste={(e) => handleFieldChange(setMinimumSalary, e.clipboardData.getData("text"), "minimumSalary")}
										disabled={!isCompanyAssoSelected}

									/>
									{/* {display && !minimumSalary ? (
										<span className="error_msg_lbl">Enter Minimum Salary</span>
									) : null} */}
								</div>

								<div className="post-form-group placeholder-from-react-select">
									<label htmlFor="about">
										Maximum Salary <span style={{ color: "red" }}>*</span>
									</label>
									<input
										type="number"
										placeholder="Type Salary"
										value={maximumSalary}
										// onChange={(e) => setMaximumSalary(e.target.value)}
										// onChange={(e) => handleFieldChange(setMaximumSalary, e.target.value)}
										onChange={(e) => handleFieldChange(setMaximumSalary, e.target.value, "maximumSalary")}
										onPaste={(e) => handleFieldChange(setMaximumSalary, e.clipboardData.getData("text"), "maximumSalary")}
										disabled={!isCompanyAssoSelected}

									/>
									{/* {display && !maximumSalary && (
										<span className="error_msg_lbl">Enter Maximum Salary</span>
									)} */}
									{maximumSalary && minimumSalary && Number(maximumSalary) < Number(minimumSalary) && (
										<span className="error_msg_lbl">Maximum Salary cannot be less than Minimum Salary</span>
									)}
								</div>
							</div>

							{/* ....................... 3 Row ......................... */}

							<div className="post-form-row my-0">
								{/* ........Salary Type........ */}

								<div className="  post-form-group placeholder-from-react-select">
									<label htmlFor="about">
										Salary Type <span className="text-danger">*</span>
									</label>
									<ReactSelect
										options={salaryTypeList}
										// onChange={handleSalaryType}
										// onChange={(option) => handleFieldChange(setSalaryTypeSearch, option ? option.value : "")} // Track changes
										onChange={(option) => handleFieldChange(setSalaryTypeSearch, option ? option.value : "", "salaryTypeSearch")}
										value={
											salaryTypeList.find(
												(option) => option.value === salaryTypeSearch
											) || null
										}
										placeholder="Select Salary Type"
										styles={customStyles}
										classNamePrefix="react-select"
										className="form-control"
										isDisabled={!isCompanyAssoSelected}
										isClearable

									// onInputChange={(inputValue) => setSalaryTypeSearch(inputValue)}
									// invalid={display && salaryTypeSearch === ""}
									/>

									{/* {display && !salaryTypeSearch ? (
										<span className="error_msg_lbl">Select Salary Type </span>
									) : null} */}
								</div>

								{/* ........Designation........ */}

								{/* <div className="post-form-group placeholder-from-react-select">
									<label htmlFor="externalUrl">Designation <span style={{ color: "red" }}>*</span></label>
									<ReactSelect
										options={designationList}
										// onChange={handleDesignation}
										onInputChange={handleDesignation}
										onChange={(option) => handleFieldChange(setDesignationSearch, option ? option.label : "")}
										value={
											designationList.find((option) => option.label === designationSearch) ||
											(designationSearch ? { label: designationSearch, value: designationSearch } : null)
										}
										// value={
										// 	designationList.find(
										// 		(option) => option.label === designationSearch
										// 	) || null
										// }
										// options={designationList}
										// onInputChange={designationInputChange}
										// onChange={(option) => handleFieldChange(setDesignationSearch, option ? option.label : "")} // Track changes
										// value={
										// 	designationList.find((option) => option.label === designationSearch) ||
										// 	(designationSearch ? { label: designationSearch, value: designationSearch } : null)
										// }
										placeholder="Select Designation"
										styles={customStyles}
										classNamePrefix="react-select"
										className="form-control"
										isDisabled={!isCompanySelected}
										isClearable
									// onInputChange={(inputValue) => setDesignationSearch(inputValue)}
									// invalid={display && designationSearch === ""}
									/>
									{display && !designationSearch ? (
										<span className="error_msg_lbl text-red">
											Select Designation
										</span>
									) : null}
								</div> */}

								<div className="post-form-group placeholder-from-react-select">
									<label htmlFor="externalUrl">Designation <span className="text-danger">*</span></label>
									<ReactSelect
										options={designationList}
										onInputChange={designationInputChange}
										// onChange={(option) => handleFieldChange(setDesignationSearch, option ? option.label : "")} // Track changes
										onChange={(option) => handleFieldChange(setDesignationSearch, option ? option.label : "", "designationSearch")}
										value={
											designationList.find((option) => option.label === designationSearch) ||
											(designationSearch ? { label: designationSearch, value: designationSearch } : null)
										}
										placeholder="Select Designation"
										styles={customStyles}
										classNamePrefix="react-select"
										className="form-control"
										isClearable
									/>
									{/* {display && !designationSearch ? (
										<span className="error_msg_lbl text-red">
											Enter Designation
										</span>
									) : null} */}
								</div>

							</div>

							{/* ....................... 4 Row ........................ */}

							{/* ........Work level type........ */}

							<div className="post-form-row my-0">
								<div className="post-form-group placeholder-from-react-select">
									<label htmlFor="about">
										Work Level Type <span style={{ color: "red" }}>*</span>
									</label>
									<ReactSelect
										options={workLevelList}
										// onChange={handleWorkLevel}
										// onChange={(option) => handleFieldChange(setworkLevelSearch, option ? option.value : "")} // Track changes
										onChange={(option) => handleFieldChange(setworkLevelSearch, option ? option.value : "", "workLevelSearch")}
										value={
											workLevelList.find(
												(option) => option.value === workLevelSearch
											) || null
										}
										placeholder="Select Work Level Type"
										styles={customStyles}
										classNamePrefix="react-select"
										className="form-control"
										isDisabled={!isCompanyAssoSelected}
										isClearable
									// onInputChange={(inputValue) => setworkLevelSearch(inputValue)}
									// invalid={display && workLevelSearch === ""}
									/>
									{/* {display && !workLevelSearch ? (
										<span className="error_msg_lbl">
											Select Work Level Type{" "}
										</span>
									) : null} */}
								</div>

								{/* ........Work location type........ */}

								<div className="post-form-group placeholder-from-react-select">
									<label htmlFor="about">
										Work Location Type{" "}
										<span style={{ color: "red" }}>*</span>
									</label>

									<ReactSelect
										options={workLocation}
										// onChange={handleWorkLoc}
										// onChange={(option) => handleFieldChange(setworkLocationSearch, option ? option.value : "")} // Track changes
										onChange={(option) => handleFieldChange(setworkLocationSearch, option ? option.value : "", "workLocationSearch")}
										value={
											workLocation.find(
												(option) => option.value === workLocationSearch
											) || null
										}
										placeholder="Select Work Location Type"
										styles={customStyles}
										classNamePrefix="react-select"
										className="form-control"
										isDisabled={!isCompanyAssoSelected}
										isClearable
									// onInputChange={(inputValue) => setworkLocationSearch(inputValue)}
									// invalid={display && workLocationSearch === ""}
									/>
									{/* {display && !workLocationSearch ? (
										<span className="error_msg_lbl">
											Select Work Location Type{" "}
										</span>
									) : null} */}
								</div>
							</div>

							{/* ....................... 5 Row ........................ */}
							<div className="post-form-row my-0">
								{/* ........ Job type........ */}
								<div className="post-form-group placeholder-from-react-select">
									<label htmlFor="about">
										Job Type <span style={{ color: "red" }}>*</span>
									</label>

									<ReactSelect
										options={jobTypeList}
										// onChange={handleJobType}
										// onChange={(option) => handleFieldChange(setjobTypeSearch, option ? option.value : "")} // Track changes
										onChange={(option) => handleFieldChange(setjobTypeSearch, option ? option.value : "", "jobTypeSearch")}
										value={
											jobTypeList.find(
												(option) => option.value === jobTypeSearch
											) || null
										}
										placeholder="Select Job Type"
										styles={customStyles}
										classNamePrefix="react-select"
										className="form-control"
										isDisabled={!isCompanyAssoSelected}
										isClearable
									// onInputChange={(inputValue) => setjobTypeSearch(inputValue)}
									// invalid={display && cityListSearch === ""}
									/>
									{/* {display && !jobTypeSearch ? (
										<span className="error_msg_lbl">Select Job Type </span>
									) : null} */}
								</div>

								{/* ........ City ........ */}
								<div className=" post-form-group placeholder-from-react-select">
									<label htmlFor="about">
										City <span className="text-danger"> *</span>
									</label>

									<ReactSelect
										options={cityList}
										// onChange={handleCitySelect}
										// onChange={(option) => handleFieldChange(setcityListSearch, option ? option.value : "")} // Track changes
										onChange={(option) => handleFieldChange(setcityListSearch, option ? option.value : "", "cityListSearch")}
										value={
											cityList.find(
												(option) => option.value === cityListSearch
											) || null
										}
										placeholder="Search & Select City"
										onInputChange={handleCityInputChange}
										styles={customStyles}
										classNamePrefix="react-select"
										className="form-control"
										isDisabled={!isCompanyAssoSelected}
										isClearable
									/>
									{/* {display && !cityListSearch ? (
										<span className="error_msg_lbl">Search & Select City </span>
									) : null} */}
								</div>
							</div>



						</div>

						<div className="post-job-form">
							<div className="post-form-group placeholder-from-react-select">
								<label htmlFor="job-title" className="post-form-label mt-0">
									Requirement <span style={{ color: "red" }}>*</span>
								</label>

								<ReactQuill
									id="job-requirement"
									className="post-description-input"
									placeholder="Type The Job Requirement Here..."
									value={requirement}
									// onChange={(e) => setRequirement(e.target.value)}
									// onChange={(value) => handleFieldChange(setRequirement, value)}
									onChange={(value) => handleFieldChange(setRequirement, value, "requirement")}
									disabled={!isCompanyAssoSelected}

								/>
								{/* {display && !requirement ? (
									<span className="error_msg_lbl">Enter Requirement</span>
								) : null} */}
							</div>
						</div>

						<div className="post-job-description py-0">
							<div className="post-form-group placeholder-from-react-select">

								<label htmlFor="job-description" className="post-form-label mt-0">
									Job Description <span style={{ color: "red" }}>*</span>
								</label>

								<ReactQuill
									id="job-description"
									className="post-description-input"
									placeholder="Type The Job Description Here..."
									value={jobDescription}
									// onChange={(e) => setjobDescription(e.target.value)}
									// onChange={(value) => handleFieldChange(setjobDescription, value)}
									onChange={(value) => handleFieldChange(setjobDescription, value, "jobDescription")}
									disabled={!isCompanyAssoSelected}

								/>
								{/* {display && !jobDescription ? (
									<span className="error_msg_lbl">Enter Job Description</span>
								) : null} */}
							</div>
						</div>

						<Button
							// className="mainBtn apply-job mb-3 mt-2"
							onClick={(e) => AddJobRecruiter(e)}
							className={`btn btn-primary mainBtn apply-job mb-3 mt-2 ${!formChanged || isSubmitting ? "disabled" : "enabled"}`}
							// onClick={!formChanged || isSubmitting ? (e) => e.preventDefault() : handleSubmit}
							disabled={!formChanged || isSubmitting}
							style={{ pointerEvents: formChanged ? "auto" : "none", border: "none" }}
						>
							Submit
						</Button>
						{/* /*... 3  */}
					</div>

				</div>
			</div>

			{/*.................................... bulk job Modal Start ................................*/}

			<Modal show={showBulkModal}
				onHide={handleCloseBulkModal}
				size="md" centered
				className="Bulk-Upload-Excel-Modal"
			>
				<Modal.Header >
					<Modal.Title>Bulk upload excel file</Modal.Title>
					<CloseSharpIcon className="pointer" onClick={handleCloseBulkModal} />

				</Modal.Header>
				<Modal.Body>
					<div className=" col-md-12 post-job-details-form p-0 pt-3 PostCard">
						<div controlId="post-form-row my-0">
							<div className="row">
								<div className="col-md-12">
									<div className="mb-2 main-company-disabled">
										<div className="post-form-group mb-0 placeholder-from-react-select">

											<label htmlFor="about">
												Company
												<span style={{ color: "red" }} className="f-500">*
													{/* {selectedAssoOptionData !== "" ? "" : "Select associate company (Or manage in setting)"} */}
												</span>
											</label>

											<ReactSelect
												options={companyListBulk}
												onChange={(option) => {
													handleFieldChangeBulk(setCompanyAssoListIdBulk, option ? option.value : "", "companyAssoListId"); //  Correct fieldName
													setCompanyAssoListIdBulk(option ? option.value : "");
													// setIsCompanyAssoSelected(!!option); //  Enable fields only when a company is selected
													// setSelectedAssoOptionData(option ? option.label : "");
													setAssoTagIdBulk(option ? option.tagId : "");
												}}
												// onPaste={(e) => handleFieldChange(setJobTitle, e.clipboardData.getData("text"), "jobTitle")}
												value={companyListBulk.find((option) => option.value === companyAssoListIdBulk) || null}
												placeholder="Select Company"
												classNamePrefix="react-select"
												className="form-control"
												styles={customStyles}
												isClearable
											/>
										</div>
									</div>
								</div>
								{/* <div className="col-md-6">
									<div><h6 className="f-700">Duplicate skip</h6></div>
									<label class="switch mt-1">
										<input
											type="checkbox"
											checked={duplicateSkip}
											onChange={handleToggle}
										/>
										<span class="slider round"></span>
									</label>
								</div> */}
							</div>


						</div>
					</div>
					<div className="row">
						<div className="col-md-6">
							<div className="pt-3 ">
								<div className="d-flex justify-content-center">
									<input
										type="file"
										accept=".xlsx,.xls"
										onChange={handleFileUpload}
										style={{
											marginTop: "15px",
											padding: "5px 10px",
											borderRadius: "5px",
											cursor: "pointer",
										}}
									/>
								</div>

							</div>
						</div>
						<div className="col-md-6 duplicate-skip-cont d-flex">
							<h6 className="f-700 me-2">Duplicate skip</h6>
							<span>
								<label class="switch mt-1">
									<input
										type="checkbox"
										checked={duplicateSkip}
										onChange={handleToggle}
									/>
									<span class="slider round"></span>
								</label>
							</span>

						</div>
					</div>
					{/* <div className="pt-3 ">
						<div className="d-flex justify-content-center">
							<input
								type="file"
								accept=".xlsx,.xls"
								onChange={handleFileUpload}
								style={{
									marginTop: "15px",
									padding: "5px 10px",
									borderRadius: "5px",
									cursor: "pointer",
								}}
							/>
						</div>

					</div> */}
				</Modal.Body>
				<div className="d-flex justify-content-center pe-3 pb-3">
					<div className="add-class-submit-button d-flex justify-content-center">
						<Button variant="secondary" onClick={handleCloseBulkModal}>
							Close
						</Button>
						{/* <div className="khojPrimaryBtn ms-3"
							style={{ height: "40px" }}
						>
							<a href="#/" onClick={uploadFile}
								className={`btn ${!formChangedBulk || isSubmittingBulk ? "disabled" : "enabled"}`}
								// disabled={!formChanged || isSubmitting}
								style={{ pointerEvents: formChangedBulk ? "auto" : "none", border: "none" }}

							>
								Upload
							</a>
						</div> */}
						{/* <div className="ms-2">
							<button
								type="button"
								className="f-500 mt-2 downloadbtn khojPrimaryBtn"
								onClick={uploadFile}
								style={{
									width: "120px",
									opacity: isDownloading ? 0.6 : 1,
									display: "flex",
									alignItems: "center",
									justifyContent: "center",
									gap: "6px"
								}}
							>
								<span>{isDownloading ? "Uploading" : "Upload"}</span>
								{isDownloading && <span className="loader"></span>}
							</button>
						</div> */}
						<div className="khojPrimaryBtn ms-3"
							style={{ height: "40px", width: "120px" }}
						>
							<a href="#/" onClick={uploadFile}
								className={`btn ${!formChangedBulk  ? "disabled" : "enabled"}`}
								// disabled={!formChanged || isSubmitting}
								style={{ pointerEvents: formChangedBulk ? "auto" : "none", border: "none" }}
							>
								{/* Upload */}
								<span>{isDownloading ? "Uploading" : "Upload"}</span>
								{isDownloading && <span className="loader"></span>}
							</a>
						</div>
					</div>
				</div>
				<hr />

				<div className="d-flex justify-content-center align-items-baseline">
					<p className="text-center mb-2">Download reference file</p>
					<div className="col-md-3">
						<div className="khoDwnlodBtn ms-3">
							{/* <Tooltip title="Download reference file" arrow> */}
							<p onClick={downloadExcel}>
								Download
							</p>
							{/* </Tooltip> */}
						</div>
					</div>
				</div>

				<div className="d-flex justify-content-center">

					{/* <div className="col-md-6 ">
						<div className="Excel-File-Box"
							style={{
								width: "100%",
								padding: "8px",
								border: "1px solid #ddd",
								borderRadius: "8px",
								textAlign: "center",
								backgroundColor: "#f9f9f9",
								marginBottom: "15px",
							}}
						>
							<p style={{ margin: "0", fontWeight: "bold" }}>Wok.xlsx</p>
						</div>
					</div> */}

				</div>
			</Modal>

			{/*.................................... bulk job Modal end ................................*/}
			{/*....................................  Job details Modal Start ................................*/}

			<Modal show={showInfoModal} onHide={handleCloseInfoModal} centered>
				<Modal.Header>
					<Modal.Title> Job Details</Modal.Title>
					<CloseSharpIcon className="pointer" onClick={handleCloseInfoModal} />
				</Modal.Header>
				<Modal.Body className="settings">
					<div className=" mb-3">
						{jobInfo.compName === "" ? '' : (
							<p>
								<span className="f-600">Company Name : </span>
								{jobInfo?.associateCompanyShortInfo?.compName}
							</p>
						)}
						{jobInfo.title === "" ? '' : (
							<p>
								<span className="f-600">Title Name : </span>
								{jobInfo.title}
							</p>
						)}
						{jobInfo.cityName === "" ? "" : (
							<p>
								<span className="f-600">City Name : </span>
								{jobInfo.cityName}
							</p>
						)}
						{jobInfo.designationName === null ? "" : (
							<p>
								<span className="f-600">Designation Name : </span>
								{jobInfo.designationName}
							</p>
						)}
						{jobInfo.workLocationTypeName === null ? "" : (
							<p>
								<span className="f-600">Work Location Name :</span> {jobInfo.workLocationTypeName}
							</p>
						)}
						{jobInfo.description && (
							<div>
								<strong className="f-600">Description : </strong>
								<div
									// dangerouslySetInnerHTML={{
									// 	__html: linkifyContent(addTargetBlankToAnchors(jobInfo.description))
									// }}
									dangerouslySetInnerHTML={{
										__html: addTargetBlankToAnchors(jobInfo.description)
									}}
								/>
							</div>
						)}
					</div>
				</Modal.Body>
				<div className="d-flex justify-content-end pe-3 pb-3">
					<div className="add-class-submit-button d-flex justify-content-center">

						<div className="khojPrimaryBtn ms-3">
							<Link to={`/job/${jobInfo.jobId}`}>
								View Jobs
							</Link>
							{/* <a href="/job/${jobInfo.}" >
							</a> */}
						</div>
						<div className="khojPrimaryBtn ms-3">
							<a href="/job/My-Jobs" >
								Jobs List
							</a>
						</div>
						{/* <div className="khojPrimaryBtn ms-3 pointer" onClick={handleSkillShow}>

							Add Skills

						</div> */}
					</div>
				</div>
			</Modal>
			{/*....................................  Job details Modal End ................................*/}

			{/*....................................  add skill Modal Start ................................*/}


			<Modal show={showaddskill} onHide={handleCloseaddskill} centered size="md">
				<Modal.Header >
					<Modal.Title>Add skills</Modal.Title>
					<CloseSharpIcon className="pointer" onClick={handleCloseaddskill} />
				</Modal.Header>
				<Modal.Body className="settings">
					<Row>
						{/* Industry Selection */}
						<Col md={12}>
							<Form.Group controlId="Industry">
								<Form.Label className="class-type">
									Industry
									<span style={{ color: "red" }} className="ms-2">
										*
									</span>
								</Form.Label>
							</Form.Group>

							<div className="post-form-group">
								<ReactSelect
									options={industryList}
									onChange={handleIndustrySelect}
									value={
										industryList.find(
											(option) => option.value === industryId
										) || null
									}
									placeholder="Select industry"
									classNamePrefix="react-select"
									className="form-control Dark-Input-from-group"
									styles={customStyles}
								/>
								{display && !industryId ? <span className='error_msg_lbl text-red'>Select industry</span> : null}

							</div>
						</Col>

						{/* Skills Section */}
						<Col md={12}>
							<Form.Group controlId="Skills">
								<Form.Label className="class-type">
									Skills
									<span style={{ color: "red" }} className="ms-2">
										*
									</span>
								</Form.Label>
							</Form.Group>

							{/* <div className="post-form-group mb-0">
								<ReactSelect

									options={skillList}
									onChange={handleSkillSelect}
									value={
										skillList.find(
											(option) => option.value === skillListId
										) || null
									}
									placeholder="Select Skills"
									classNamePrefix="react-select"
									className="form-control Dark-Input-from-group"
									styles={customStyles}
								// isDisabled={!selectedIndustryId} // Disable until industry is selected

								/>
								{display && !skillListId ? <span className='error_msg_lbl text-red'>Select Skill</span> : null}

							</div> */}
							<div className="post-form-group mb-0">
								<ReactSelect
									options={combinedOptions}
									onInputChange={handleInputChange}
									onChange={handleChange}
									value={selectedSkills}
									placeholder="Select skills"
									classNamePrefix="react-select"
									className="form-control"
									styles={customStyles}
									isMulti
									isClearable
								/>
								{display && !skillListId ? (
									<span className="error_msg_lbl text-red">Select skill</span>
								) : null}
							</div>

						</Col>
					</Row>

					{/* Submit Button */}
					<div className="add-class-submit-button mt-4 d-flex justify-content-center">
						<div className="khojPrimaryBtn ms-3"
						onClick={handleSubmit}
						style={{ cursor: formChanged ? "pointer" : "default" }}
						>
							<a href="#/" className=""
							//  onClick={handleSubmit}
							 >
								Submit
							</a>
						</div>
					</div>
				</Modal.Body>
			</Modal>
			{/*....................................  add skill Modal End ................................*/}

		</>
	);
};

export default PostJobRecruiter;
